export default "__VITE_ASSET__DiJXwphH__"